module.exports = {
  PREFIX: "00000000-0000-0000-0000-",
  SERVICE_ID: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0000",
  SERVICE_NAME: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0001",
  DEVICE_MODEL: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0002",
  WIFI_NAME: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0003",
  IP_ADDRESS: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0004",
  INPUT: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0005",
  NOTIFY_MESSAGE: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0006",
  INPUT_SEP: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0007",
  CUSTOM_COMMAND_INPUT: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0008",
  CUSTOM_COMMAND_NOTIFY: "FD2B4448-AA0F-4A15-A62F-EB0BE77A0009",
  CUSTOM_INFO_LABEL: "FD2BCCCA",
  CUSTOM_INFO_COUNT: "FD2BCCAA0000",
  CUSTOM_INFO: "FD2BCCCB",
  CUSTOM_COMMAND_LABEL: "FD2BCCCC",
  CUSTOM_COMMAND_COUNT: "FD2BCCAC0000"
};
